function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.65 15.925a3.728 3.728 0 00-3.6 2.775H.975c-.2 0-.35.15-.35.35v1.175c0 .2.15.35.35.35H5.05a3.728 3.728 0 003.6 2.775 3.728 3.728 0 003.6-2.775h11.775c.2 0 .35-.15.35-.35V19.05c0-.2-.15-.35-.35-.35H12.25a3.728 3.728 0 00-3.6-2.775zm1.825 3.7c0 1-.825 1.825-1.825 1.825s-1.825-.825-1.825-1.825S7.65 17.8 8.65 17.8s1.825.825 1.825 1.825zM12.75 11.55H.975c-.2 0-.35.15-.35.35v1.175c0 .2.15.35.35.35H12.75a3.728 3.728 0 003.6 2.775 3.728 3.728 0 003.6-2.775h4.075c.2 0 .35-.15.35-.35V11.9c0-.2-.15-.35-.35-.35H19.95a3.728 3.728 0 00-3.6-2.775 3.728 3.728 0 00-3.6 2.775zm5.425.95c0 1-.825 1.825-1.825 1.825s-1.825-.825-1.825-1.825.825-1.825 1.825-1.825 1.825.825 1.825 1.825zM8.65 1.65a3.728 3.728 0 00-3.6 2.775H.975c-.2 0-.35.15-.35.35V5.95c0 .2.15.35.35.35H5.05a3.728 3.728 0 003.6 2.775 3.728 3.728 0 003.6-2.775h11.775c.2 0 .35-.15.35-.35V4.775c0-.2-.15-.35-.35-.35H12.25a3.728 3.728 0 00-3.6-2.775zm1.825 3.725c0 1-.825 1.825-1.825 1.825s-1.825-.825-1.825-1.825S7.65 3.55 8.65 3.55s1.825.8 1.825 1.825z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h25v25H0z"
})));

var SvgOperations = function SvgOperations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOperations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/operations.40117f23.svg";
export { ForwardRef as ReactComponent };